import { render, staticRenderFns } from "./ProductsListInStock.vue?vue&type=template&id=3fa4a006&scoped=true"
import script from "./ProductsListInStock.vue?vue&type=script&lang=js"
export * from "./ProductsListInStock.vue?vue&type=script&lang=js"
import style0 from "./ProductsListInStock.vue?vue&type=style&index=0&id=3fa4a006&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fa4a006",
  null
  
)

export default component.exports